// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2V5Df","question":"Question_question__hXtZz","description":"Question_description__31TNE"};